
document.body.addEventListener(
  'submit',
  function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (!form.classList.contains('form_validate')) return;

    let isValid = true;

    const allOldErrors = form.querySelectorAll('.error-msg');
    for (var i = allOldErrors.length - 1; i >= 0; i--) allOldErrors[i].remove();

    const requiredInputs = form.querySelectorAll('[data-required]');

    requiredInputs.forEach((input) => {
      const value = input.value?.trim();
      const msg = input.getAttribute('data-required') || 'Trường bắt buộc';

      const borderTag = input.closest('.filter-ib') || input;
      const groupTag = borderTag.parentElement;

      if (!value) {
        isValid = false;

        if (!groupTag.querySelector('.error-msg')) {
          const errorEl = document.createElement('div');
          errorEl.className = 'error-msg';
          errorEl.textContent = msg;
          groupTag.appendChild(errorEl);
        }
      }
    });

    if (!isValid) {
      e.preventDefault();
    }
  },
  true // 👉 Dùng capture để chạy trước React
);

document.body.addEventListener('input', function (e) {
  const input = e.target;
  if (!(input instanceof HTMLInputElement)) return;

  const borderTag = input.closest('.filter-ib') || input;
  const groupTag = borderTag.parentElement;
  const errorTag = groupTag.querySelector('.error-msg');

  if (input.value.trim() && errorTag) {
    errorTag.remove();
  }
});
